var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkIndicatorNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11143_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.40967 5.57324L25.8225 26.9275",
    stroke: "#991F27",
    strokeWidth: 2.42661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0868 26.9275C18.1589 26.9275 19.0281 26.0584 19.0281 24.9862C19.0281 23.9141 18.1589 23.0449 17.0868 23.0449C16.0146 23.0449 15.1455 23.9141 15.1455 24.9862C15.1455 26.0584 16.0146 26.9275 17.0868 26.9275Z",
    fill: "#991F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27312 8.72803C7.1761 9.49489 5.22357 10.6102 3.4978 12.027",
    stroke: "#991F27",
    strokeWidth: 2.42661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7346 12.027C25.1802 9.10301 20.7188 7.50761 16.1163 7.51467C15.2644 7.51435 14.4134 7.56825 13.5684 7.67604",
    stroke: "#991F27",
    strokeWidth: 2.42661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6628 13.5518C11.3667 13.9543 9.2073 14.9235 7.38037 16.3715",
    stroke: "#991F27",
    strokeWidth: 2.42661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8519 16.3717C23.1365 15.0107 21.1261 14.0703 18.9819 13.626",
    stroke: "#991F27",
    strokeWidth: 2.42661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.369 19.8283C18.0545 19.2658 16.6165 19.0541 15.1957 19.2138C13.7749 19.3735 12.4198 19.8992 11.2629 20.7395",
    stroke: "#991F27",
    strokeWidth: 2.42661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11143_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0605,
    height: 31.0607,
    fill: "white",
    transform: "translate(0.585449 0.720215)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIndicatorNone);
export default __webpack_public_path__ + "static/media/network_indicator_none.4fab6c8fc47ec5767d763ce8091c2ea6.svg";
export { ForwardRef as ReactComponent };